
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Department Approved',
      icon: 'ri-government-line',
      color: 'bg-red-100 text-red-600'
    },
    {
      name: 'EN54',
      description: 'European Fire Detection Standard',
      icon: 'ri-europe-line',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      name: 'ISO 9001',
      description: 'Quality Management System',
      icon: 'ri-award-line',
      color: 'bg-green-100 text-green-600'
    },
    {
      name: 'CE Marking',
      description: 'European Conformity',
      icon: 'ri-checkbox-circle-line',
      color: 'bg-purple-100 text-purple-600'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Certifications & Compliance</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our manual call points meet the highest international standards and local regulatory requirements
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {certifications.map((cert, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
              <div className={`w-16 h-16 ${cert.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${cert.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{cert.name}</h3>
              <p className="text-sm text-gray-600">{cert.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 text-white">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-4">Regulatory Compliance</h3>
              <p className="text-gray-300 mb-6">
                All FlameGuardQA manual call points are rigorously tested and certified to meet Qatar's fire safety regulations and international standards.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-green-400"></i>
                  <span>QCDD Type Approval Certificate</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-green-400"></i>
                  <span>EN54-11 Manual Call Point Standard</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-green-400"></i>
                  <span>IP65 Environmental Protection</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-green-400"></i>
                  <span>ISO 9001 Quality Assurance</span>
                </li>
              </ul>
            </div>
            <div className="text-center">
              <div className="w-32 h-32 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-5xl text-white"></i>
              </div>
              <p className="text-lg font-semibold">Certified for Qatar Market</p>
              <p className="text-gray-300">Approved by QCDD for commercial and residential use</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
